<div class="row" *ngIf="initialData">
    <div class="col-12">
        <div class="button-bar">
            <app-button iconName="search" (clickEvent)="openComparison()" tooltip="Voir le détail" *ngIf="initialData.left?.frames?.length > 0 && initialData.right?.frames?.length > 0"></app-button>
            <app-button iconName="x" (clickEvent)="initialData = undefined" tooltip="Supprimer l\'analyse"></app-button>
        </div>
    </div>
    <div class="col-12 col-lg-6 col-xl-6 text-right">
        <img src="{{initialData.left?.image}}" *ngIf="initialData.left?.image"/>
    </div>
    <div class="col-12 col-lg-6 col-xl-6 text-left">
        <img src="{{initialData.right?.image}}" *ngIf="initialData.right?.image"/>
    </div>
</div>

<app-materialize-plate-exam-dynamic (changedEvent)="changed($event)" *ngIf="!initialData"></app-materialize-plate-exam-dynamic>